import TextCell from '@components/ListV2/components/table/cells/TextCell';
import Link from '@components/v2/ui/Link/Link';
import Typography from '@components/v2/ui/Typography/Typography';
import useWidth from '../../../../components/Hooks/useWidth';
import LangEnum from '../../../../lang/LangEnum';
import PATHS from '../../../../routes/routes.const';
import { useApplicationContext } from '../../../context/ApplicationContext/ApplicationContext';
import { UsedInOfflineMode } from '../../../offline/types/UsedInOfflineMode';
import { useTranslation } from '../../../translation/TranslationContext';

interface CustomerLinkCell extends UsedInOfflineMode {
  customerId: number | string | undefined;
  customerCommercialName: string | undefined;
  customerCompanyName: string | undefined;
  disableLink?: boolean;
  hideCompanyName?: boolean;
}

const CustomerLinkCell = ({
  customerId,
  customerCommercialName,
  customerCompanyName,
  disableLink,
  hideCompanyName,
  isOfflineMode: _usedInOfflineMode,
}: CustomerLinkCell) => {
  const { isStore } = useApplicationContext();
  const { mobileWidth } = useWidth();
  const { translate } = useTranslation();

  if (!customerId) {
    return <Typography color="text.tertiary">{translate(LangEnum.GLOBAL_NO_CLIENT)}</Typography>;
  }

  const secondField = hideCompanyName ? undefined : customerCompanyName;

  if (isStore || disableLink) {
    return <TextCell firstField={customerCommercialName} secondField={secondField} />;
  }

  return (
    <Link
      component="span"
      role="link"
      color="text.primary"
      sx={{ display: 'block' }}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        window.open(`${PATHS.main.customers.path}/${customerId}`, mobileWidth ? '_self' : '_blank');
      }}
    >
      <TextCell firstField={customerCommercialName} secondField={secondField} />
    </Link>
  );
};

export default CustomerLinkCell;
